<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 33 40"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.5 9V2.41421L22.7929 5.70711L26.0858 9H19.5Z" :stroke="fill" stroke-width="2"/>
    <path clip-rule="evenodd" d="M3.5 0H18.5V2H3.5C2.94772 2 2.5 2.44772 2.5 3V32C2.5 32.5523 2.94772 33 3.5 33H12.5V35H3.5C1.84315 35 0.5 33.6569 0.5 32V3C0.5 1.34315 1.84315 0 3.5 0ZM28.5 16V10H26.5V16H28.5Z" :fill="fill" fill-rule="evenodd"/>
    <rect :fill="fill" height="1" rx="0.5" width="14" x="7.5" y="13"/>
    <rect :fill="fill" height="1" rx="0.5" width="9" x="7.5" y="18"/>
    <path clip-rule="evenodd" d="M31.1913 24.3999C31.4961 24.1456 31.5 24.0062 31.5 24.0002V24V24V24C31.5 23.9981 31.5009 23.8583 31.1913 23.6001C30.8862 23.3455 30.3849 23.0713 29.6776 22.8217C28.272 22.3256 26.2647 22 24 22C21.7353 22 19.728 22.3256 18.3224 22.8217C17.6151 23.0713 17.1138 23.3455 16.8087 23.6001C16.4991 23.8583 16.5 23.9981 16.5 24L16.5 24L16.5 24L16.5 24.0002C16.5 24.0065 16.5042 24.1459 16.8087 24.3999C17.1138 24.6545 17.6151 24.9287 18.3224 25.1783C19.728 25.6744 21.7353 26 24 26C26.2647 26 28.272 25.6744 29.6776 25.1783C30.3849 24.9287 30.8862 24.6545 31.1913 24.3999ZM24 27C27.2469 27 30.0686 26.3575 31.5 25.413V28.7935C31.1322 29.0969 30.5744 29.392 29.844 29.6498C28.3721 30.1693 26.3059 30.5 24 30.5C21.6941 30.5 19.6279 30.1693 18.156 29.6498C17.4256 29.392 16.8678 29.0969 16.5 28.7935V25.413C17.9314 26.3575 20.7531 27 24 27ZM32.5 29.2143V28V24C32.5 22.3431 28.6944 21 24 21C19.3056 21 15.5 22.3431 15.5 24V28V29.2143V32V33.2143V36.5039H16.5V33.9998C16.8857 34.2218 17.3324 34.4196 17.8232 34.5928C19.4277 35.1591 21.6115 35.5 24 35.5C26.3885 35.5 28.5723 35.1591 30.1768 34.5928C30.6676 34.4196 31.1143 34.2218 31.5 33.9998V36.5039H32.5V33.2143V32V29.2143ZM16.5 32.7935C16.8678 33.0969 17.4256 33.392 18.156 33.6498C19.6279 34.1693 21.6941 34.5 24 34.5C26.3059 34.5 28.3721 34.1693 29.844 33.6498C30.5744 33.392 31.1322 33.0969 31.5 32.7935V29.9998C31.1143 30.2218 30.6676 30.4196 30.1768 30.5928C28.5723 31.1591 26.3885 31.5 24 31.5C21.6115 31.5 19.4277 31.1591 17.8232 30.5928C17.3324 30.4196 16.8857 30.2218 16.5 29.9998V32.7935Z" :fill="fill" fill-rule="evenodd"/>
    <path clip-rule="evenodd" d="M16.5 35C15.8618 35.4211 15.5 35.9021 15.5 36.413C15.5 38.0699 19.3056 39.413 24 39.413C28.6944 39.413 32.5 38.0699 32.5 36.413C32.5 35.9021 32.1382 35.4211 31.5 35V36.4128C31.5 36.4129 31.5 36.413 31.5 36.413V36.413V36.413C31.5 36.4149 31.5009 36.5547 31.1913 36.813C30.8862 37.0676 30.3849 37.3417 29.6776 37.5913C28.272 38.0875 26.2647 38.413 24 38.413C21.7353 38.413 19.728 38.0875 18.3224 37.5913C17.6151 37.3417 17.1138 37.0676 16.8087 36.813C16.4991 36.5547 16.5 36.4149 16.5 36.413L16.5 36.413L16.5 36.413C16.5 36.413 16.5 36.4129 16.5 36.4128V35Z" :fill="fill" fill-rule="evenodd"/>
  </svg>
</template>

<script>
export default {
  name: 'Loans',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
